/*
 * HomeState.js
 *
 * Initialisation of Home page
 *
 */

/*
 * Initialises the home page section
 */
function InitialiseHomePage () {
	g_remote_object.FetchHTMLFromServer('', ParseHomeData, 'info', 'home');
}

function ParseHomeData (p_owner, p_data) {
	VRC.CurrentVoyage.init();

	$("#home_voyage_info").html(p_data);
}